// const wsBaseHref = process.env.WS_HOST_BASE;
// DEV:
// export const wsBaseHref = 'http://159.149.3.86:9001/api';
// PROD:
export const wsBaseHref = 'https://www.elmariachistudios.it/ws';
// export const wsBaseHref = 'https://www.elmariachistudios.it/testws';

// exporting authentication urls
// DEV:
// export const serverUrl = "http://159.149.3.86:9001";
// PROD:
export const serverUrl ="https://www.elmariachistudios.it/"
export const feUrl = "https://www.legapauperitalia.com"
// DEV:
// export const sdkConfig = {
//   serverUrl: "http://159.149.3.86:8000",
//   clientId: "1ff4ba2eb5b5ebf79044",
//   appName: "pauperleaguemanager",
//   organizationName: "built-in",
//   redirectPath: "/web/callback",
//   signinPath: "/api/signin",
// };
// PROD:
export const sdkConfig = {
  serverUrl: "https://login.elmariachistudios.it",
  clientId: "fa98151e8ccb96f0a3ee",
  appName: "pauperleaguemanager",
  organizationName: "LPMartesana",
  redirectPath: "/callback",
  signinPath: "/signin",
};

// console.warn(process.env.PUBLIC_URL);
export const basepath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}/`
  : '/'; 

export const api = {
  me: () => ({
    href: `${wsBaseHref}/userInfo`,
  }),
  meLogin: () => ({
     href: `${wsBaseHref}/login`,
  }),
  leagues: () => {
    const leagueHref = `${wsBaseHref}/leagues`;
    const tournamentsHref = `${wsBaseHref}/tournaments`;
    return {
      detailsById: (id) => ({
        href: `${leagueHref}/${id}`,
      }),
      getEvents: (id) => ({
        href: `${tournamentsHref}?fromLeague=${id}`,
      }),
      list: (queries) => {
        if (queries) return { href: `${leagueHref}?activeOnly=${queries.active}`}
        return { href: leagueHref}
      },
      lpiZones: () => ({
        href: `${wsBaseHref}/lpizones`,
      }),
      getSeasons: (id) => ({
        href: `${leagueHref}/${id}/seasons`,
      }),
      // fetch(wsBaseHref+"/leagues/"+props.leagueId+"/addLocation"
      addLocation: (id) => ({
        href: `${leagueHref}/${id}/addLocation`,
      }),
      removeLocation: (id) => ({
        href: `${leagueHref}/${id}/removeLocation`,
      }),
      create: () => ({
        href: `${leagueHref}/createLeague`,
      }),
      update: () => ({
        href: `${leagueHref}/editLeague`,
      })
    }
  },
  seasons: () => {
      const seasonHRef = `${wsBaseHref}/seasons`;
      return {
        detailsById: (id) => ({
          href: `${seasonHRef}/${id}`,
        }),
        detailsBySlug: (slug) => ({
          href: `${seasonHRef}/${slug}`,
        }),
        list: () => ({
          href: seasonHRef,
        }),
        addStage: (id) => ({
          href: `${seasonHRef}/${id}/createstage`,
        }),
        getStages: (id) => ({
          href: `${seasonHRef}/${id}/stages`,
        }),
        getRanking: (id) => ({
          href: `${seasonHRef}/${id}/ranking`,
        }),
        getMetagame: (id) => ({
          href: `${seasonHRef}/${id}/metagameStats`,
        }),
        create: () => ({
          href: `${seasonHRef}/createseason`,
        }),
        update: (id) => ({
          href: `${seasonHRef}/${id}/update`,
        }),
      }
  },
  stages: () => {
    const stagesHref = `${wsBaseHref}/stages`;
    return {
      detailsById: (id) => ({
        href: `${stagesHref}/${id}`,
      }),
      players: (id) => ({
        href: `${stagesHref}/${id}/participants`,
      }),
      waitlist: (id) => ({
        href: `${stagesHref}/${id}/waitlist`,
      }),
      addPlayer: (id) => ({
        href: `${stagesHref}/${id}/addParticipant`,
      }),
      removePlayer: (id) => ({
        href: `${stagesHref}/${id}/removeParticipant`,
      }),
      setRanking: (id) => ({
        href: `${stagesHref}/${id}/setRanking`,
      }),
      subscribe: (id) => ({
        href: `${stagesHref}/${id}/subscribe`,
      }),
      create: (seasonId) => ({
        href: `${wsBaseHref}/seasons/${seasonId}/createstage`,
      }),
      update: (id) => ({
        href: `${stagesHref}/${id}/update`,
      }),
      delete: (id) => ({
        href: `${stagesHref}/${id}/delete`,
      }),
      importResults: (id) => ({
        href: `${stagesHref}/${id}/importResults`,
      }),
      importStore: (id) => ({
        href: `${stagesHref}/${id}/importStore`,
      })
    }
  },
  tournaments: () => {
    const tournamentsHref = `${wsBaseHref}/tournaments`;
    return {
      detailsById: (id) => ({
        href: `${tournamentsHref}/${id}/`,
      }),
      decklists: (id) => ({
        href: `${tournamentsHref}/${id}/downloadDecklists`,
      }),
      list: () => ({
        href: `${tournamentsHref}?upcoming=false`,
      }),
      filteredList: (types, fromDate, toDate, temporalOrder) => ({
        href: `${tournamentsHref}?fromDate=${fromDate}&toDate=${toDate}&type=${types.join(',')}&temporalOrder=${temporalOrder}`,
      }),
      upcoming: () => ({
        href: `${tournamentsHref}?upcoming=true`,
      }),
      create: () => ({
        href: `${tournamentsHref}/create`,
      }),
      update: () => ({
        href: `${tournamentsHref}/update`,
      }),
      players: (id) => ({
        href: `${tournamentsHref}/${id}/participants`,
      }),
      addLocation: (id) => ({
        href: `${tournamentsHref}/${id}/setLocation`,
      }), 
      removeLocation: (id) => ({
        href: `${tournamentsHref}/${id}/removeLocation`,
      }),
      addPlayer: (id) => ({
        href: `${tournamentsHref}/${id}/addParticipant`,
      }),
      removePlayer: (id) => ({
        href: `${tournamentsHref}/${id}/removeParticipant`,
      }),
      setRanking: (id) => ({
        href: `${tournamentsHref}/${id}/setRanking`,
      }),
      importResults: (id) => ({
        href: `${tournamentsHref}/${id}/importResults`,
      }),
      importStore: (id) => ({
        href: `${tournamentsHref}/${id}/importStore`,
      }),
      listTypes: () => ({
        href: `${tournamentsHref}/types`,
      }),
      listMultipliers: () => ({
        href: `${tournamentsHref}/multipliers`,
      }),
      lpiSeasonsList: () => ({
        href: `${wsBaseHref}/lpiseasons`,
      })
    }
  },
  rankings: () => {
    const rankHref = `${wsBaseHref}/rankings`;
    return {
      list: () => ({
        href: rankHref,
      })
    };
  },
  players: () => {
    const playerHref = `${wsBaseHref}/players`;
    return {
      list: () => ({
        href: playerHref,
      }),
      detailsById: (id) => ({
        href: `${playerHref}/${id}`,
      }),
      create: () => ({
        href: `${playerHref}/createPlayer`,
      })
    }
  },
  places: () => {
    const placeHref = `${wsBaseHref}/places`;
    return {
      list: () => ({
        href: placeHref,
      }),
      detailsById: (id) => ({
        href: `${placeHref}/${id}`,
      })
    }
  },
  platforms: () => {
    const platformHref = `${wsBaseHref}/platforms`;
    return {
      list: () => ({
        href: platformHref,
      }),
      detailsById: (id) => ({
        href: `${platformHref}/${id}`,
      })
    }
  },
  decks: () => {
    const deckHref = `${wsBaseHref}/decks`;
    return {
      list: () => ({
        href: deckHref,
      }),
      detailsById: (id) => ({
        href: `${deckHref}/${id}`,
      }),
      archetypesList: () => ({
        href: `${wsBaseHref}/decknames`,
      }),
      add: (eventId,isTournament,playerId) => ({
        href: `${wsBaseHref}/decklist/add?eventId=${eventId}&isTournament=${isTournament}&playerId=${playerId}`,
      })
    }
  },
  byes: () => {
    const byesHref = `${wsBaseHref}/bye`;
    return {
      list: () => ({
        href: `${byesHref}/list`,
      }),
      detailsById: (id) => ({
        href: `${byesHref}/${id}`,
      }),
      assign: () => ({
        href: `${byesHref}/assign`,
      })
    }
  },
  users: () => {
    const usersHref = `${wsBaseHref}/users`;
    return {
      list: () => ({
        href: usersHref,
      })
    }
  }
};